var _circle, _g, _rect, _rect2, _rect3, _path, _path2, _rect4, _rect5, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoItems({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 221,
    viewBox: "0 0 220 221",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 110.5,
    r: 110,
    fill: "#E6F1FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5680_126705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52 46C52 43.7909 53.7909 42 56 42H162C164.209 42 166 43.7909 166 46V174C166 176.209 164.209 178 162 178H56C53.7909 178 52 176.209 52 174V46Z",
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 107,
    width: 82,
    height: 5,
    rx: 2.5,
    fill: "#E3E6EA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 120,
    width: 38,
    height: 5,
    rx: 2.5,
    fill: "#E3E6EA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 56,
    width: 40,
    height: 40,
    rx: 4,
    fill: "#C7DDF7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M107.839 65.954C110.069 62.9239 114.405 62.2355 117.524 64.4165C120.642 66.5975 121.363 70.8219 119.133 73.8521L114.647 79.9482L110.161 86.0444C107.931 89.0745 103.595 89.7629 100.476 87.5819C97.3574 85.4009 96.6369 81.1764 98.8668 78.1463L103.353 72.0502L107.839 65.954Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M114.647 79.9488L110.161 86.045C107.931 89.0751 103.595 89.7635 100.476 87.5825C97.3574 85.4015 96.6369 81.1771 98.8668 78.1469L103.353 72.0508L114.647 79.9488Z",
    fill: "#0070CD"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 138,
    width: 66,
    height: 25,
    rx: 12.5,
    stroke: "#E3E6EA",
    strokeWidth: 4
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 105.5,
    y: 144.5,
    width: 8,
    height: 11,
    rx: 4,
    stroke: "#E3E6EA",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M124.5 150.5H133.5",
    stroke: "#E3E6EA",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5 150.5H94.5",
    stroke: "#E3E6EA",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M129 146L129 155",
    stroke: "#E3E6EA",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5680_126705",
    x: 36,
    y: 30,
    width: 146,
    height: 168,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.722656 0 0 0 0 0.821815 0 0 0 0 0.9375 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5680_126705"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5680_126705",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoItems);
export default __webpack_public_path__ + "static/media/noItems.8b96f3536bf7caa782e16fa3fb717ae5.svg";
export { ForwardRef as ReactComponent };